import { render, staticRenderFns } from "./ModalPassport.vue?vue&type=template&id=f10eb446&"
import script from "./ModalPassport.vue?vue&type=script&lang=js&"
export * from "./ModalPassport.vue?vue&type=script&lang=js&"
import style0 from "./ModalPassport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports